"use client";

import Box from "@mui/material/Box";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { CldImage } from "next-cloudinary";
import { ItemDataPlaceholder } from "./constants";

const Photo: React.FC<ItemDataPlaceholder> = (props) => {
  return (
    <Box
      component="li"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box>
        <CldImage
          src={props.src}
          width={props.width}
          height={props.height}
          crop="thumb"
          zoom="0.1"
          gravity="faces"
          preload
          alt={`${props.title} in ${props.location}`}
          style={{
            borderRadius: "20px",
          }}
          {...(!!props.blurDataURL && {
            placeholder: "blur",
            blurDataURL: props.blurDataURL,
          })}
        />
        <ImageListItemBar
          title={props.title}
          subtitle={props.location}
          position="below"
        />
      </Box>
    </Box>
  );
};

export default Photo;
